import React, { useState } from 'react';
import md5 from 'js-md5';
import { cn } from '@/lib/utils';

export function AvatarImage({ user, src, className, size = 48, ...props }) {
  const [imgError, setImgError] = useState(false);

  // 1. Prioritize: Explicit src > DB avatar > Google Meta
  const imageSrc = src || user?.avatar_url || user?.user_metadata?.avatar_url;

  // 2. Gravatar / Fallback Logic
  const email = user?.email || user?.username;
  const cleanEmail = (email || 'unknown').trim().toLowerCase();
  const hash = md5(cleanEmail);
  const gravatarUrl = `https://www.gravatar.com/avatar/${hash}?d=retro&s=${size * 2}`;

  // UI Avatar (Initials) as last resort or if no email
  const uiAvatarUrl = `https://ui-avatars.com/api/?name=${encodeURIComponent(user?.full_name || user?.email || 'User')}&background=random`;

  if (imageSrc && !imgError) {
    return (
      <img
        src={imageSrc}
        alt={user?.full_name || 'User'}
        className={cn("rounded-full object-cover bg-gray-200 border border-gray-100", className)}
        style={{ width: size, height: size }}
        onError={() => setImgError(true)}
        {...props}
      />
    );
  }

  // Fallback: If no email, force UI Avatar immediately
  if (!email && user?.full_name) {
    return (
      <img
        src={uiAvatarUrl}
        alt={user.full_name}
        className={cn("rounded-full bg-gray-100 border border-gray-200", className)}
        style={{ width: size, height: size }}
        {...props}
      />
    );
  }

  // Standard Gravatar Fallback
  return (
    <img
      src={gravatarUrl}
      alt={user?.full_name || 'User'}
      className={cn("rounded-full bg-gray-100 border border-gray-200", className)}
      style={{ width: size, height: size }}
      onError={(e) => {
        e.target.onerror = null;
        e.target.src = uiAvatarUrl;
      }}
      {...props}
    />
  );
}
